import React from "react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { RefreshCw, Mail } from "lucide-react";

const INQUIRY_STATUS_STYLE = {
  neu: "bg-blue-50 text-blue-700 border-blue-200",
  in_bearbeitung: "bg-amber-50 text-amber-700 border-amber-200",
  abgeschlossen: "bg-green-50 text-green-700 border-green-200",
};

export const InquiriesTab = ({ inquiries, fetchInquiries, setInquiryStatus }) => (
            <div data-testid="inquiries-view" className="space-y-4 max-w-4xl">
              <div className="flex items-center justify-between">
                <h2 className="font-[Playfair_Display] text-lg font-semibold text-[var(--brand-ink)]">White-Label-Anfragen ({inquiries.length})</h2>
                <Button variant="outline" size="sm" onClick={fetchInquiries} data-testid="inquiries-refresh"><RefreshCw className="w-4 h-4 mr-1" /> Aktualisieren</Button>
              </div>
              {inquiries.length === 0 ? (
                <Card className="p-10 text-center bg-white border-[var(--brand-border)]">
                  <Mail className="w-10 h-10 text-[var(--brand-muted)] mx-auto mb-3" />
                  <p className="text-[var(--brand-muted)]">Noch keine Anfragen eingegangen.</p>
                </Card>
              ) : (
                <div className="space-y-3">
                  {inquiries.map((q) => (
                    <Card key={q.id} className="p-5 bg-white border-[var(--brand-border)]" data-testid="inquiry-card">
                      <div className="flex flex-wrap items-start justify-between gap-3 mb-2">
                        <div>
                          <div className="font-semibold text-[var(--brand-ink)]">{q.name}{q.company ? ` · ${q.company}` : ""}</div>
                          <div className="text-sm text-[var(--brand-muted)]">
                            <a href={`mailto:${q.email}`} className="hover:underline">{q.email}</a>
                            {q.phone ? ` · ${q.phone}` : ""}
                          </div>
                          <div className="text-xs text-[var(--brand-muted)] mt-0.5">{q.created_at ? new Date(q.created_at).toLocaleString("de-DE") : ""}</div>
                        </div>
                        <select
                          value={q.status || "neu"}
                          onChange={(e) => setInquiryStatus(q.id, e.target.value)}
                          data-testid="inquiry-status-select"
                          className={`text-xs rounded-full px-3 py-1.5 border font-medium cursor-pointer ${INQUIRY_STATUS_STYLE[q.status || "neu"]}`}
                        >
                          <option value="neu">Neu</option>
                          <option value="in_bearbeitung">In Bearbeitung</option>
                          <option value="abgeschlossen">Abgeschlossen</option>
                        </select>
                      </div>
                      {q.message && <p className="text-sm text-[var(--brand-ink)] whitespace-pre-wrap bg-[var(--brand-border-light)] rounded-lg p-3 mt-2">{q.message}</p>}
                    </Card>
                  ))}
                </div>
              )}
            </div>

);
